import { Union } from "../../fable_modules/fable-library-js.4.17.0/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.4.17.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { comparePrimitives, createObj } from "../../fable_modules/fable-library-js.4.17.0/Util.js";
import { Interop_reactApi } from "../../fable_modules/Feliz.2.7.0/Interop.fs.js";
import { singleton, ofArray } from "../../fable_modules/fable-library-js.4.17.0/List.js";
import { Dimensions_TextSmall } from "../Design.js";
import { sortByDescending, map } from "../../fable_modules/fable-library-js.4.17.0/Array.js";
import { Time_utcStringToLocalTimeSpan, Time_utcStringToLocalDaySpan, Format_quoteToString, Format_formatSpacedNumber, Time_utcDateToLocalDate, Format_toShortAmount } from "../Utils.js";
import { format } from "../../fable_modules/fable-library-js.4.17.0/String.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.4.17.0/Seq.js";

export class PostType extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ShortEvent", "InsiderTrade", "Dividend"];
    }
}

export function PostType_$reflection() {
    return union_type("Aksjeio.Posts.SystemPost.PostType", [], PostType, () => [[], [], []]);
}

function missingInfo(txt) {
    let elems;
    return createElement("div", createObj(ofArray([["style", {}], (elems = [createElement("p", {
        children: [txt],
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
}

function td$0027(txt) {
    return createElement("td", {
        style: {
            padding: 3,
        },
        children: txt,
    });
}

function drawShortEventPost(post) {
    let matchValue_1, elems_2, elems, elems_1, children_8, children_2, children, children_6;
    const th$0027 = (title) => createElement("th", {
        style: {
            fontSize: Dimensions_TextSmall,
            padding: 3,
        },
        children: title,
    });
    const matchValue = post.ShortInfo;
    if (matchValue != null) {
        const si = matchValue;
        const percentageChange = ((matchValue_1 = si.PrevPercentage, (matchValue_1 != null) ? (si.NewPercentage - matchValue_1) : si.NewPercentage)) / 100;
        const includePlus = (percentageChange > 0) ? "+" : "";
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            gap: ((20 + "px ") + 20) + "px",
            padding: ((20 + "px ") + 0) + "px",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRight: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        }], (elems = [createElement("span", {
            style: {
                fontSize: Dimensions_TextSmall,
                userSelect: "none",
            },
            children: "Andel short",
        }), createElement("span", {
            style: {
                fontSize: 2.5 + "rem",
                userSelect: "none",
            },
            children: `${si.NewPercentage / 100}%`,
        }), createElement("span", {
            style: {
                fontSize: Dimensions_TextSmall,
                userSelect: "none",
            },
            children: `${includePlus}${percentageChange} pp. endring`,
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflowX: "hidden",
        }], (elems_1 = [(children_8 = ofArray([(children_2 = singleton((children = ofArray([th$0027("Kjøper/selger"), th$0027("Aksjer"), th$0027("Endring")]), createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        }))), createElement("thead", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        })), (children_6 = map((p_2) => {
            const change = (p_2.NewNumShares - p_2.PrevNumShares) | 0;
            const includePlus_1 = (change > 0) ? "+" : "";
            const children_4 = ofArray([createElement("td", {
                style: {
                    maxWidth: 200,
                    whiteSpace: "nowrap",
                    overflowX: "hidden",
                    textOverflow: "ellipsis",
                    padding: ((0 + "px ") + 3) + "px",
                },
                children: p_2.Institution,
            }), td$0027(Format_toShortAmount(p_2.NewNumShares)), td$0027(`${includePlus_1}${Format_toShortAmount(change)}`)]);
            return createElement("tr", {
                children: Interop_reactApi.Children.toArray(Array.from(children_4)),
            });
        }, sortByDescending((p_1) => (p_1.NewNumShares - p_1.PrevNumShares), si.Positions, {
            Compare: comparePrimitives,
        })), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_6)),
        }))]), createElement("table", {
            children: Interop_reactApi.Children.toArray(Array.from(children_8)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }
    else {
        return missingInfo("Kunne ikke laste informasjon om shortposisjon. Vennligst prøv igjen senere.");
    }
}

function drawDividendPost(post) {
    let elems_2, elems, elems_1, children_4, children_2;
    const infoRow = (header, info) => {
        const children = ofArray([createElement("th", {
            style: {
                maxWidth: 200,
                whiteSpace: "nowrap",
                overflowX: "hidden",
                textOverflow: "ellipsis",
                padding: ((0 + "px ") + 3) + "px",
            },
            children: header,
        }), td$0027(info)]);
        return createElement("tr", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        });
    };
    const matchValue = post.DividendInfo;
    if (matchValue != null) {
        const di = matchValue;
        const am = format('{0:' + "0.00" + '}', di.Amount);
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            gap: ((20 + "px ") + 20) + "px",
            padding: ((20 + "px ") + 0) + "px",
        }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRight: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        }], (elems = toList(delay(() => append(singleton_1(createElement("span", {
            style: {
                fontSize: Dimensions_TextSmall,
                userSelect: "none",
            },
            children: "Utbytte",
        })), delay(() => append(singleton_1(createElement("span", {
            style: {
                fontSize: 2.5 + "rem",
                userSelect: "none",
            },
            children: `${di.Currency} ${am}`,
        })), delay(() => {
            const matchValue_1 = di.NOKAmount;
            const matchValue_2 = di.ExchangeRate;
            let matchResult, ee, na;
            if (matchValue_1 != null) {
                if (matchValue_2 != null) {
                    matchResult = 0;
                    ee = matchValue_2;
                    na = matchValue_1;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0: {
                    const na$0027 = format('{0:' + "0.00" + '}', na);
                    const ee$0027 = format('{0:' + "0.00" + '}', ee);
                    return singleton_1(createElement("span", {
                        style: {
                            userSelect: "none",
                            fontSize: 0.86 + "rem",
                        },
                        children: `NOK ${na$0027} basert på vekslingskurs NOK ${ee$0027} / ${di.Currency}`,
                    }));
                }
                default: {
                    return empty();
                }
            }
        })))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems))])]))), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
            overflowX: "hidden",
        }], (elems_1 = [(children_4 = singleton((children_2 = ofArray([infoRow("Ex-dato", Time_utcDateToLocalDate(di.ExDate)), infoRow("Annonsert", Time_utcDateToLocalDate(di.AnnouncementDate)), infoRow("Utbetales", Time_utcDateToLocalDate(di.PaymentDate))]), createElement("tbody", {
            children: Interop_reactApi.Children.toArray(Array.from(children_2)),
        }))), createElement("table", {
            children: Interop_reactApi.Children.toArray(Array.from(children_4)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])])));
    }
    else {
        return missingInfo("Kunne ikke laste informasjon om utbytte. Vennligst prøv igjen senere.");
    }
}

function drawInsiderTradePost(post) {
    let elems, elems_6;
    const matchValue = post.InsiderInfo;
    if (matchValue != null) {
        const ii = matchValue;
        const tradeColor = (ii.NumShares > 0) ? "var(--buy)" : ((ii.NumShares < 0) ? "var(--sell)" : "var(--text-main)");
        const indicator = createElement("div", createObj(ofArray([["className", "pill-button"], ["style", {
            backgroundColor: "#fff",
            color: tradeColor,
            cursor: "auto",
            userSelect: "none",
        }], (elems = [createElement("span", {
            style: {
                fontWeight: "bold",
            },
            children: (ii.NumShares > 0) ? "Kjøpt" : ((ii.NumShares < 0) ? "Solgt" : "Flyttet/annet"),
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
        const flexColumn$0027 = (x) => createElement("div", {
            style: {
                display: "flex",
                flexDirection: "column",
            },
            children: Interop_reactApi.Children.toArray(Array.from(x)),
        });
        const infoLabel = (txt) => createElement("span", {
            style: {
                fontSize: Dimensions_TextSmall,
            },
            children: txt,
        });
        const contentText = (txt_1) => createElement("span", {
            style: {
                fontSize: 1.225 + "rem",
                userSelect: "none",
            },
            children: txt_1,
        });
        return createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "space-between",
            gap: ((10 + "px ") + 10) + "px",
            padding: ((20 + "px ") + 0) + "px",
        }], (elems_6 = toList(delay(() => {
            let elems_4, elems_2, elems_3;
            return append(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                flexGrow: 1,
                gap: ((10 + "px ") + 10) + "px",
            }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: ((20 + "px ") + 0) + "px",
                backgroundColor: tradeColor,
                borderRadius: 5,
                padding: 10,
                width: 100 + "%",
            }], ["className", "insider-trade-indicator"], (elems_2 = [indicator, createElement("span", {
                style: {
                    fontWeight: "bold",
                    fontSize: 1.225 + "rem",
                    color: "#FFFFFF",
                    userSelect: "none",
                },
                children: `${Format_formatSpacedNumber(ii.NumShares)} aksjer`,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                gap: ((10 + "px ") + 0) + "px",
            }], (elems_3 = toList(delay(() => append(singleton_1(flexColumn$0027(toList(delay(() => append(singleton_1(infoLabel("Innsider")), delay(() => append(singleton_1(contentText(ii.Insider)), delay(() => ((ii.Role.length > 0) ? singleton_1(createElement("span", {
                style: {
                    fontSize: Dimensions_TextSmall,
                    userSelect: "none",
                    maxWidth: 250,
                    overflowX: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                },
                children: `- ${ii.Role}`,
            })) : empty()))))))))), delay(() => {
                const matchValue_1 = ii.NewTotal;
                if (matchValue_1 != null) {
                    const nt = matchValue_1 | 0;
                    return singleton_1(flexColumn$0027([infoLabel("Antall aksjer etter handel"), contentText(Format_formatSpacedNumber(nt))]));
                }
                else {
                    return empty();
                }
            })))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                let elems_5;
                const matchValue_2 = ii.AvgPrice;
                if (matchValue_2 != null) {
                    const ap = matchValue_2;
                    const wasExchanged = (ii.ExchangeInfo != null) ? "*" : "";
                    return singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexGrow: 1,
                        justifyContent: "space-between",
                        gap: ((10 + "px ") + 0) + "px",
                    }], ["className", "insider-trade-avg-price"], (elems_5 = [flexColumn$0027([infoLabel(`Snittpris${wasExchanged}`), contentText(`NOK ${Format_quoteToString(ap)}`)]), flexColumn$0027([infoLabel("Verdi av handel"), contentText(Format_toShortAmount(~~(ap * ii.NumShares)))])], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])]))));
                }
                else {
                    return empty();
                }
            }));
        })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])));
    }
    else {
        return missingInfo("Kunne ikke laste informasjon om innsidehandel. Vennligst prøv igjen senere.");
    }
}

export function Post(postInputProps) {
    let elems_11, elems_2, elems_10, elems_9;
    const post = postInputProps.post;
    const type$0027 = postInputProps["type\'"];
    const compId = postInputProps.compId;
    const eventTime = (type$0027.tag === 2) ? Time_utcStringToLocalDaySpan(post.Published) : ((type$0027.tag === 1) ? Time_utcStringToLocalDaySpan(post.Published) : Time_utcStringToLocalTimeSpan(post.Published));
    const sourceLink = (sourceUrl) => {
        let elems;
        return createElement("a", createObj(ofArray([["href", sourceUrl], ["target", "_blank"], (elems = [createElement("i", {
            className: "fas fa-link",
            style: {
                marginRight: 5,
            },
        }), createElement("span", {
            children: ["Til børsmelding"],
        })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))])])));
    };
    return createElement("div", createObj(ofArray([["className", "post"], ["key", compId], ["style", {
        border: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
        borderRadius: 5,
    }], (elems_11 = [createElement("div", createObj(ofArray([["className", "post-header"], (elems_2 = toList(delay(() => {
        let elems_1;
        const matchValue = post.AssetInfo;
        if (matchValue != null) {
            const si = matchValue;
            return singleton_1(createElement("a", createObj(ofArray([["href", `/stock/${si.Market}/${si.Ticker}`], (elems_1 = [createElement("span", {
                style: {
                    fontSize: 1.225 + "rem",
                },
                children: si.Name,
            })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_1))])]))));
        }
        else {
            return singleton_1(createElement("span", {
                children: (type$0027.tag === 1) ? "Mangler informasjon om innsidehandel. Vennligst prøv igjen senere." : ((type$0027.tag === 2) ? "Mangler informasjon om utbytte. Vennligst prøv igjen senere." : "Mangler short informasjon. Vennligst prøv igjen senere."),
            }));
        }
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["className", "post-content-holder"], (elems_10 = [createElement("div", createObj(ofArray([["className", "post-content"], (elems_9 = toList(delay(() => {
        let elems_4, elems_3, children;
        return append(singleton_1(createElement("div", createObj(ofArray([["style", {
            borderBottom: (((1 + "px ") + "solid") + " ") + "#e1e1e1",
            fontSize: Dimensions_TextSmall,
            display: "flex",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: ((0 + "px ") + 20) + "px",
        }], (elems_4 = [createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: ((0 + "px ") + 20) + "px",
        }], (elems_3 = toList(delay(() => append(singleton_1(createElement("span", {
            style: {
                fontWeight: "bold",
            },
            children: (type$0027.tag === 1) ? "Innsidehandel" : ((type$0027.tag === 2) ? "Utbytte" : "Shortoppdatering"),
        })), delay(() => append(singleton_1(createElement("span", {
            children: [eventTime],
        })), delay(() => {
            const matchValue_1 = post.ShortInfo;
            let matchResult;
            if (type$0027.tag === 0) {
                if (matchValue_1 != null) {
                    matchResult = 0;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton_1(createElement("span", {
                        children: [`Posisjonsdato: ${Time_utcDateToLocalDate(matchValue_1.PositionDate)}`],
                    }));
                default: {
                    return empty();
                }
            }
        })))))), ["children", Interop_reactApi.Children.toArray(Array.from(elems_3))])]))), (children = toList(delay(() => {
            switch (type$0027.tag) {
                case 1: {
                    const matchValue_3 = post.InsiderInfo;
                    if (matchValue_3 != null) {
                        return singleton_1(sourceLink(matchValue_3.SourceUrl));
                    }
                    else {
                        return empty();
                    }
                }
                case 2: {
                    const matchValue_4 = post.DividendInfo;
                    if (matchValue_4 != null) {
                        return singleton_1(sourceLink(matchValue_4.SourceUrl));
                    }
                    else {
                        return empty();
                    }
                }
                default: {
                    return empty();
                }
            }
        })), createElement("div", {
            children: Interop_reactApi.Children.toArray(Array.from(children)),
        }))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
            let matchValue_5;
            return append((matchValue_5 = type$0027, (matchValue_5.tag === 1) ? singleton_1(drawInsiderTradePost(post)) : ((matchValue_5.tag === 2) ? singleton_1(drawDividendPost(post)) : singleton_1(drawShortEventPost(post)))), delay(() => {
                let elems_6, matchValue_7, matchValue_8, ei, elems_7, elems_5;
                const matchValue_6 = type$0027;
                return (matchValue_6.tag === 2) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                    fontSize: Dimensions_TextSmall,
                    color: "var(--text-dim)",
                }], (elems_6 = [createElement("span", {
                    children: ["Dette utbyttet er AI-generert fra børsmeldingen. Med forbehold om feil."],
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_6))])])))) : ((matchValue_6.tag === 1) ? append((matchValue_7 = post.InsiderInfo, (matchValue_7 != null) ? ((matchValue_8 = matchValue_7.ExchangeInfo, (matchValue_8 != null) ? ((ei = matchValue_8, singleton_1(createElement("div", createObj(ofArray([["style", {
                    fontSize: Dimensions_TextSmall,
                    color: "var(--text-dim)",
                }], (elems_7 = [createElement("i", {
                    className: "fas fa-info-circle",
                    style: {
                        marginRight: 6,
                        marginLeft: 2,
                    },
                }), createElement("span", {
                    children: [`*Denne handelen ble meldt som ${ei.Currency}${Format_quoteToString(ei.AvgPrice)} og konvertert til NOK. NOK verdi er estimert.`],
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_7))])])))))) : (empty()))) : (empty())), delay(() => {
                    let elems_8;
                    return singleton_1(createElement("div", createObj(ofArray([["style", {
                        fontSize: Dimensions_TextSmall,
                        color: "var(--text-dim)",
                    }], (elems_8 = [createElement("i", {
                        className: "fas fa-robot",
                        style: {
                            marginRight: 5,
                        },
                    }), createElement("span", {
                        children: ["Denne oppsummeringen er AI-generert fra børsmeldingen. Med forbehold om feil."],
                    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_8))])]))));
                })) : singleton_1(createElement("div", createObj(ofArray([["style", {
                    fontSize: Dimensions_TextSmall,
                    color: "var(--text-dim)",
                }], (elems_5 = [createElement("span", {
                    children: ["Basert på short-posisjoner større eller lik 0.5% av utestående aksjer."],
                })], ["children", Interop_reactApi.Children.toArray(Array.from(elems_5))])])))));
            }));
        }));
    })), ["children", Interop_reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", Interop_reactApi.Children.toArray(Array.from(elems_11))])])));
}

